<div class="view hm-black-light home-banner">
    <div class="full-bg-img">
        <div class="container">
            <div class="d-flex align-items-center d-flex justify-content-center" style="height: 600px">
                <div class="row mt-5">
                    <div class="col-md-12 wow fadeIn mb-3">

                        <div class="intro-info-content text-center" *ngIf="!storageAccessRequired">
                            <!-- <h1 class="h1-responsive mb-2 wow fadeInDown text-uppercase white-text" data-wow-delay="0.3s">{{title}}</h1> -->
                            <h2 class="h2-responsive mb-2 wow fadeInDown text-uppercase white-text" *ngIf="!ssoFailed">
                                <app-spin-icon class="pl-2"></app-spin-icon>Loading up your account</h2>
                            <h2 class="h2-responsive mb-2 wow fadeInDown text-uppercase white-text" *ngIf="ssoFailed">
                                There was an error loading the application. 
                            </h2>
                            <h2 class="h2-responsive mb-2 wow fadeInDown text-uppercase white-text" *ngIf="ssoFailed">
                                    Contact support for assistance.
                            </h2>
                        </div>
                        <div class="intro-info-content text-center" *ngIf="storageAccessRequired">
                            <h2 class="h2-responsive mb-2 wow fadeInDown text-uppercase white-text">
                                In order to use the assessment service to both take and save your assessment data, you must grant storage access. 
                            </h2>
                            <a (click)="grantStorageAccess()" class="btn btn-lg">Grant Access</a>
                            <h2 class="h2-responsive mb-2 wow fadeInDown text-uppercase white-text">
                                    Contact support for assistance, if you have any questions.
                            </h2>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/login/sso/sso.component.html